import { render, staticRenderFns } from "./CurrencyRatesList.vue?vue&type=template&id=d02b2b8e&"
import script from "./CurrencyRatesList.vue?vue&type=script&lang=js&"
export * from "./CurrencyRatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports